export const SIMULAB_INPUT_CHARACTER_LIMIT = 500
export const SIMULAB_WARNING_CHARACTER_NUMBER = 450
export const SHOW_DETAIL_MODAL_KEY = "DontShowDetailModal"
export const PDF_FILE_URL =
    "https://5729375.fs1.hubspotusercontent-na1.net/hubfs/5729375/Spot Coaching Laminated Card - Digital_05102024.pdf"
